/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import './SweepModal.scss';

import { string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import BaseModal from 'components/shared/Modal/BaseModal';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { getBrokerageAccountsFromSweepMap } from 'state/account/AccountSelectors';

const AccountNumber = ({ accountWChecksum }) => (
  <Fragment>{accountWChecksum}</Fragment>
);

const AccountNumberWithPermissions = WithUserPermissions(AccountNumber);

class SweepModal extends BaseModal {
  constructor(props) {
    super(props);
  }
  containerClassName() {
    const { className = '' } = this.props;
    return `modal-info-container modal-sweep-container ${className}`;
  }

  renderLinkContent() {
    return '';
  }

  renderModalContent() {
    const { accountId, accountWChecksum, sweepAccountsMap } = this.props;
    const sweepAccount = sweepAccountsMap[accountId];
    const accountWChecksumOption = sweepAccount
      ? `${sweepAccount.accountNumber}-${sweepAccount.accountChecksum}`
      : accountWChecksum;

    return (
      <div className="sweep-info">
        <p>
          This Money Market fund is linked to your Brokerage Account #
          <AccountNumberWithPermissions
            accountWChecksum={accountWChecksumOption}
            shouldMask
          />
          .
        </p>
        <p>
          Securities transactions and/or cash distributions from positions held
          in that specific brokerage account will settle in or out of this
          &quot;sweep&quot; account.
        </p>
      </div>
    );
  }
}

SweepModal.propTypes = {
  accountWChecksum: string,
  className: string,
  content: string
};

SweepModal.defaultProps = {
  title: 'Sweep Account'
};

const mapStateToProps = (state) => ({
  sweepAccountsMap: getBrokerageAccountsFromSweepMap(state)
});

export default connect(mapStateToProps)(SweepModal);
